import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, forwardRef, HostListener, Input, OnInit, Optional, Output, Self, ViewChild } from '@angular/core';
import { AbstractControl, ControlValueAccessor, FormControl, NgControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator, ValidatorFn, Validators } from '@angular/forms';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { QuestionnaireService } from '../services/questionnaire.service';

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  // providers:[{
  //   provide:NG_VALUE_ACCESSOR,
  //   useExisting:DatePickerComponent,
  //   multi:true
  // }
  // ]
})
export class DatePickerComponent implements OnInit, ControlValueAccessor {
  @Input() minDate: any;
  @Input() maxDate: any;
  @Input() firstDayOfWeek: any;
  @Input() placeholder: string;
  @Input() attAriaLabel: any;
  @Input() attrDateID: any
  showErrorBorder: boolean = false;
  control: AbstractControl;
  value: any = '';
  submitted: boolean = false;
  @Output() public onUpdate: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('butOpenCalendar') butOpenCalendar: ElementRef;
  @ViewChild('d2') d2: any;

  hasToggled: boolean = false;

  constructor(@Self() @Optional() private ngControl: NgControl,
    private _changeDetector: ChangeDetectorRef, private questionnaireService: QuestionnaireService) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  public onChange = (_: any) => { }
  public onTouched = (_: any) => { }

  ngOnInit() {
    this.errors;
    this.questionnaireService.submitted$.subscribe(isSubmitted => {
      if (isSubmitted) {
        this.control.markAsTouched();
        this.submitted = true;
        if (!this._changeDetector['destroyed']) {
          this._changeDetector.detectChanges();
        }
      } else {
        this.control.markAsUntouched();
        this.submitted = false;
        if (!this._changeDetector['destroyed']) {
          this._changeDetector.detectChanges();
        }
      }
    })
  }
  get errors() {
    const control = this.ngControl && this.ngControl.control

    if (control) {
      this.control = control;
      return control.touched && control.errors;
    }
    return null;
  }

  writeValue(obj: any): void {
    this.value = obj;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
  }

  update($event) {
    if (this.checkRegex($event)) {
      this.onUpdate.emit($event)
      this.onChange($event);
      this.d2.close();
    }
  }

  private checkRegex(str) {
    const regex = new RegExp(/^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/i, 'i');
    if (str && str.day && str.month && str.year && str.year.toString().length >= 4) {
      return regex.test(str.day.toString() + '/' + str.month.toString() + '/' + str.year.toString());
    }
    return false;
  }

  toggleD2() {
    if (this.hasToggled === false) {
      this.d2.toggle();
    }
    
  }

  focusHandler() {
    this.d2.toggle();
    this.hasToggled = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/date-picker/date-picker.component.ts